import { useMutation, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { TransitStatus } from '@e-origin/shared';

import { showErrorToast } from '@hooks/showErrorToast';
import { request } from '@utils';

interface ChangeTransitStatusParams {
  transitId: string;
  status: TransitStatus;
}

export const useChangeTransitStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ transitId, status }: ChangeTransitStatusParams) => {
      return request({
        path: `admin/transit-status/${transitId}`,
        method: 'PATCH',
        authenticate: true,
        dataObject: { status },
      });
    },
    onSuccess: () => {
      toast.success('Transit status updated!');
      queryClient.invalidateQueries({ queryKey: ['admin-transits'] });
    },
    onError: (error: any) => {
      showErrorToast(error, 'Error updating transit status!');
    },
  });
};
